import { ActiviteComponent } from "./Activite";
import { ActiviteAssocieeComponent } from "./ActiviteAssociee";
import { CompetenceBloquanteComponent } from "./CompetenceBloquante";
import { CompetenceDeterminanteComponent } from "./CompetenceDeterminante";
import { CompetenceLieeComponent } from './CompetenceLiee'
import { CompetencePrincipaleComponent } from "./CompetencePrincipale";
import { MergeCompetenceDeterminanteComponent } from "./MergeCompetenceDeterminante";

export const ActiviteRoutes = [
    {
        path: '/config/activite',
        element: <ActiviteComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/competencebloquante',
        element: <CompetenceBloquanteComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/competencedeterminante',
        element: <CompetenceDeterminanteComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/mergecompetencedeterminante',
        element: <MergeCompetenceDeterminanteComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/competenceliee',
        element: <CompetenceLieeComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/activiteassociee',
        element: <ActiviteAssocieeComponent />,
        role: 'Pocahontas_Config'
    },
    {
        path: '/config/competenceprincipale',
        element: <CompetencePrincipaleComponent />,
        role: 'Pocahontas_Config'
    }
];